export const moduleRoutes = {
  root: 'storeAdmin',
  childForms: {
    unknownDevice: {
      data: { title: 'Dispositivo no registrado' },
      requireAuth: false,
      functions: [],
      route: 'newdevice',
    },
    terminals: {
      data: { title: 'Terminales' },
      requireAuth: false,
      functions: [],
      route: 'terminals',
    },
    users: {
      data: { title: 'Usuarios' },
      requireAuth: false,
      functions: [],
      route: 'users',
    },
    devices: {
      data: { title: 'Dispositivos' },
      requireAuth: false,
      functions: [],
      route: 'devices',
    },
    agentStores: {
      data: { title: 'Puntos' },
      requireAuth: false,
      functions: [],
      route: 'stores',
    },
    shifts: {
      data: { title: 'Turnos' },
      requireAuth: true,
      functions: [],
      route: 'shifts',
    },
    shiftDetail: {
      data: { title: 'Turno' },
      requireAuth: true,
      functions: [],
      route: 'shift-detail',
    },
    adminGroups: {
      data: { title: 'Grupos' },
      requireAuth: true,
      functions: [],
      route: 'groups',
    },
    notifications: {
      data: { title: 'Notificaciones' },
      requireAuth: true,
      functions: [],
      route: 'notifications',
    },
  },
  layout: 'main',
  loadChildren: () => import('src/app/pages/store-admin/store-admin.module').then(m => m.StoreAdminModule),
};
